import { render, staticRenderFns } from "./accordion-extended.vue?vue&type=template&id=035d76f4&scoped=true&lang=html"
import script from "./accordion-extended.vue?vue&type=script&lang=js"
export * from "./accordion-extended.vue?vue&type=script&lang=js"
import style0 from "./accordion-extended.vue?vue&type=style&index=0&id=035d76f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035d76f4",
  null
  
)

export default component.exports